let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2aI3U")).then(() => parcelRequire('3wO03'));